import '@/style/HandModal.css';
import rulesmat from '@/assets/mats/rulesmat.png';

const RulesmatModal = ({ onClose }) => {
	const rulesmatWidth = '99%';
	// const rulesmatHeight = '18vh';

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<h2 className="modal-title">Rulesmat</h2>
				<div className="hand">
					<img
						src={rulesmat}
						alt={'rulesmat-img'}
						width={rulesmatWidth}
					/>
				</div>
			</div>
		</div>
	);
	// for zoom img: className="card-img"
};

export default RulesmatModal;
